var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5a2 2 0 012-2h2.793a2 2 0 011.77 1.069l.296.564a.5.5 0 00.443.267H17a2 2 0 012 2V9H6.5L3 19v3a2 2 0 01-2-2V5z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 22a2 2 0 01-2-2V5a2 2 0 012-2h2.793a2 2 0 011.77 1.069l.296.564a.5.5 0 00.443.267H17a2 2 0 012 2V8h1.256a2 2 0 011.904 2.612l-3.214 10A2 2 0 0117.042 22H3zM17 6.15a.75.75 0 01.75.75V8H7.41a2 2 0 00-1.884 1.327L2.25 18.5V5A.75.75 0 013 4.25h2.793a.75.75 0 01.663.4l.297.565a1.75 1.75 0 001.549.935H17zM3.838 20.75h13.204a.75.75 0 00.714-.52l3.215-10a.75.75 0 00-.715-.98H7.41c-.317 0-.6.2-.707.498l-3.571 10a.75.75 0 00.706 1.002z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.6a.6.6 0 01.6-.6h1.8a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6H9.6a.6.6 0 01-.6-.6v-1.8zM13 16.6a.6.6 0 01.6-.6h1.8a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6h-1.8a.6.6 0 01-.6-.6v-1.8zM16 13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11.955 18.425l-1.135-2.222a.354.354 0 00-.64 0l-1.135 2.222c-.132.259.043.575.32.575h2.27c.277 0 .452-.316.32-.575z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.e6062937fc21e16b1f9a4b74b78ed096.svg";
export { ForwardRef as ReactComponent };